import { useRef } from 'react';
import { Alert, Loader, Modal, Select } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Button } from '../../../components/Button';
import { useQrCamera } from '../useQrCamera';
import type { useBasketQrImport } from '../useBasketQrImport';
import classes from '../digital-menu.module.scss';

export function BasketQrScannerModal({ state }: { state: ReturnType<typeof useBasketQrImport> }) {
  const video = useRef<HTMLVideoElement>(null);
  const camera = useQrCamera(state.opened && !state.busy && !state.error && !state.result, video, state.scan);
  return <Modal opened={state.opened} onClose={state.close} title={<span dir="rtl">סרוק <bdi dir="ltr">QR</bdi></span>} dir="rtl" centered size="md" closeButtonProps={{ 'aria-label': 'סגירת סריקת הסל' }}>
    <div className={classes.qrScanner}>
      {!state.result && !state.error && !state.busy && <>
        {camera.cameras.length > 1 && <Select label="מצלמה" placeholder="בחירת מצלמה" data={camera.cameras.map((entry, index) => ({ value: entry.id, label: entry.label || `מצלמה ${index + 1}` }))} value={camera.cameraId} onChange={camera.setCameraId} allowDeselect={false} searchable={false} />}
        <div className={classes.qrCameraPreview} data-ready={camera.ready}>
          <video ref={video} autoPlay muted playsInline controls={false} disablePictureInPicture disableRemotePlayback aria-label="מצלמת סריקת סל" />
          {!camera.ready && <div className={classes.qrCameraPlaceholder} aria-hidden="true"><FontAwesomeIcon icon={faCamera as IconProp} /></div>}
        </div>
      </>}
      {state.busy && <div role="status"><Loader size="sm" /><span>מוסיף פריטים להזמנה...</span></div>}
      {(state.error || camera.error) && <Alert color="red" role="alert">{state.error || camera.error}</Alert>}
      {state.result && <>
        <p role="status">נוספו {state.result.added} פריטים להזמנה</p>
        {state.result.skipped.length > 0 && <Alert color="orange" title="פריטים שלא אושרו"><ul>{state.result.skipped.map((message, index) => <li key={index}>{message}</li>)}</ul></Alert>}
      </>}
      {!state.busy && <Button variant="confirm" onClick={state.close}>סגירה</Button>}
    </div>
  </Modal>;
}